import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import classNames from "./classNames";
import GV from "../../services/globalVar";
import PettycashServiceService from "../../services/pettycash-service";
import {
  DataTable,
  Column,
  Dropdown,
  InputText,
  MultiSelect,
  iconSet,
  IcomoonReact,
  Checkbox,
  Dialog,
  Tooltip,
} from "../PrimeReact.js";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import NewPettyCash from "./NewPettyCash";
import CashTopup from "./CashTopup";
import {
  format,
  subMonths,
  addMonths,
  startOfWeek,
  addDays,
  isSameDay,
  lastDayOfWeek,
  getWeek,
  addWeeks,
  subWeeks,
  parseISO,
} from "date-fns";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import { BlockUI } from "primereact/blockui";
import { ProgressSpinner } from "primereact/progressspinner";
import { Calendar } from "primereact/calendar";
import { DatePicker, Space } from 'antd';
export default function PettyCash({ showDetailsHandle }) {
  const location = useLocation();
  const [pettycashClosed, setPettycashClosed] = useState(() => {
    const { startDate, endDate } = location.state || {};
    return { startDate, endDate };
});

  const { startDate, endDate } = location.state || {};
  const [date, setDate] = useState(new Date());
  const [currentdate, setcurrentdate] = useState(new Date());
  const [dateSelected, setDateSelected] = useState(new Date());
  const navigate = useNavigate();
  const [dateRange, setDateRange] = useState(null);

  // var first = currentdate.getDate() - currentdate.getDay(); // First day is the day of the month - the day of the week
  // var two = first + 1;
  // var three = first + 2;
  // var four = first + 3;
  // var five = first + 4;
  // var six = first + 5;
  // var seven = first + 6;

  // var firstday = new Date(currentdate.setDate(first)).toUTCString();
  // var secondday = new Date(currentdate.setDate(two)).toUTCString();
  // var thirdday = new Date(currentdate.setDate(three)).toUTCString();
  // var fourthday = new Date(currentdate.setDate(four)).toUTCString();
  // var fifthday = new Date(currentdate.setDate(five)).toUTCString();
  // var sixthday = new Date(currentdate.setDate(six)).toUTCString();
  // var seventhday = new Date(currentdate.setDate(seven)).toUTCString();
  const [gridMessage, setGridMessage] = useState("");
  const [weekdays, setweekdays] = useState([]);
  const modalref = useRef(null);
  const modalrefone = useRef(null);
  const pts = new PettycashServiceService();
const { RangePicker } = DatePicker;
  const [pettycash, setPettycash] = useState([]);
  const [isMounted, setIsMounted] = useState(true);
  const [tdataLoad, setTdataLoad] = useState(false);
  const [monthlyView, setMonthlyView] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalRecordsIn, setTotalRecordsIn] = useState(0);
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [sortName, setSortName] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [searchVal, setSearchVal] = useState("");
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [monthlyViewDatas, setMonthlyViewDatas] = useState([]);
  const [dayTransactions, setDayTransactions] = useState([]);
  const [dayTransactionsShowBtn, setDayTransactionsShowBtn] = useState([]);
  const [afterNewItem, setafterNewItem] = useState(false);
  const [dayDetails, setDayDetails] = useState(false);
  const [first1, setFirst1] = useState(0);
  const [pettyDetails, setPettyDetails] = useState();
  const [visibleDetail, setVisibleDetail] = useState();
  const [detailsTrans, setDetailsTrans] = useState();
  const [itemId, setItemId] = useState("");
  const [findUnClosedMonth, setFindUnClosedMonth] = useState([]);
  const [currentDate, setCurrentDate] = useState(null);
  const [nextWeekAvailable, setNextWeekAvailable] = useState(true); 

  const panelHeaderTemplate = () => {
    return (
      <div className="pt-2 ps-4">
        {/* <p className='mb-0 fs-6'>Select</p> */}
      </div>
    );
  };
  const columns = [
    { field: "piDescription", header: "Purchase Description" },

    { field: "status", header: "Status" },
    { field: "itemType", header: "Type" },
  ];
  const onColumnToggle = (event) => {
    let selectedColumns = event.value;
    let orderedSelectedColumns = columns.filter((col) =>
      selectedColumns.some((sCol) => sCol.field === col.field)
    );
    setSelectedColumns(orderedSelectedColumns);
  };

  const onSelect = (val) => {
    if (!val.isfuture) {
      const dayValues = weekdays;
      dayValues.forEach((x, i) => {
        if (x.date === val.date) {
          x.value = true;
        } else {
          x.value = false;
        }
      });
      setweekdays(dayValues);
      setDateSelected(val.fulldate);
      // setweekdays(weekdays => weekdays.map((x, i) => x.date  === val ? x.value = true : x.value = false));
      fetchItemList(page, sizePerPage, searchVal, "", "", val.fulldate);
    }
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {
          pettyDetails?.status !== "Week Closed" &&
          pettyDetails?.status !== "Month Closed" ? (
            <IcomoonReact
              iconSet={iconSet}
              color="#444"
              size={20}
              icon="edit"
              className="pointer"
              onClick={() => editProduct(rowData)}
            />
          ) : (
            <i
              className="pi pi-eye"
              style={{ color: "slateblue" }}
              onClick={() => {
                setVisibleDetail(true);
                setDetailsTrans(rowData);
              }}
            ></i>
          )
          //  <IcomoonReact iconSet={iconSet} color="#444" size={20} icon="pi-eye" className='pointer' onClick={() => editProduct(rowData)} />
        }
      </React.Fragment>
    );
  };
  const gstCont = (rowData) => {
    return (
      <div>
        {/* {rowData.isGST ? <i className="pi pi-check-square"></i>: <Checkbox  checked={rowData.isGST}></Checkbox>}  */}
        <Checkbox checked={rowData.isGST} disabled></Checkbox>
      </div>
    );
  };

  const getSelectedDate = (e) => {
    setTdataLoad(true);
    setDayDetails(true);
    const data = {
      TenantID: GV.userDet.tenantDetail.tenantID,
      TransactionDate: e.monthDate.split("T")[0],
    };
    pts.GetPettyCashTransactions(data).then((res) => {
      setTdataLoad(false);
      setDayTransactions(res.data.data);
    });
  };

  const dynamicColumns = selectedColumns.map((col, i) => {
    return (
      <Column
        key={col.field}
        field={col.field}
        header={col.header}
        sortable={col.sortable}
        body={col.body && actionBodyTemplate}
      ></Column>
    );
  });

  const onCustomPage1 = (event) => {
    setFirst1(event.first);
    const val = event.page + 1;
    const size = event.rows;
    setSizePerPage(size);
    setPage(val);
    fetchItemList(val, size, searchVal, "", "", dateSelected);
  };
  //sort start
  const [lazyParams, setLazyParams] = useState({
    first: first1,
    rows: sizePerPage,
    page: page,
    sortField: sortName,
    sortOrder: sortOrder,
  });
  const onSort = (event) => {
    setLazyParams(event);
  };
  //sort end
  function fetchItemList(
    page,
    sizePerPage,
    searchVal,
    sortName,
    sortOrder,
    date
  ) {
    // setTdataLoad(true);
    setTdataLoad(true);
    let data = {
      InputParams: {
        TenantID: GV.userDet.tenantDetail.tenantID,
        TransactionDate: format(date, "yyyy-MM-dd"),
      },
      ServerSearchables: {
        draw: 1,
        searchData: searchVal || "",
        orderByColumn: sortName,
        orderBy: sortOrder,
        currentPage: page,
        pageSize: sizePerPage,
        pageNumber: page,
      },
    };
    pts
      .GetPettyCashListSearch(data)
      .then((response) => {
        // if (isMounted) "Succ
        setTdataLoad(false);
    // essfully retrieved Items" "Failed to retrieve Items" {
        if (response.data.message != "Day does not opened") {
          if (response.data) {
            const grid = response.data.data.pettyCashList.transactionList;
            setGridMessage(response.data.message);
            // if (response.data.statusCode ===200) {
            // if(response.data.message !== 'Data Retrived'){
            //  }
            setTotalRecordsIn(
              response.data.data.serverSearchables.recordsTotal
            );
            setData(grid);
            setPettyDetails(response.data.data.pettyCashList);
            // setRequestData(response.data.data.itemsList);
            //   setData(requestData.slice(0,sizePerPage));
            setTdataLoad(false);

            // }
            // else if (response.data.statusCode ===500 ) {

            //     setData([]);
            //     // setRequestData([]);
            //     setTotalRecordsIn(0);
            // }
            // }
          }
        } else {
          setTotalRecordsIn(response.data.data.serverSearchables.recordsTotal);
          setGridMessage(response.data.message);
          setData([]);
          setPettyDetails([]);
        }
        // if (response.data) {
        //     const grid = response.data.data.itemsList;
        //     setTotalRecordsIn(response.data.data.serverSearchables.recordsTotal);
        //     setData(grid);
        //     setRequestData(response.data.data.itemsList);
        //     setTdataLoad(false);
        // }
      })
      .catch(function (error) {
        // if (error.data.statusCode === 500 ) {
        //     setData([]);
        //     // setRequestData([]);
        //     setTotalRecordsIn(0);
        // }
      });
  }

  //start
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [currentWeek, setCurrentWeek] = useState(getWeek(currentMonth));
  const [selectedDate, setSelectedDate] = useState(new Date());

  const changeWeekHandle = (btnType) => {
    let newMonth;
    let newWeek;
  
    if (btnType === "prev") {
      newMonth = subWeeks(currentMonth, 1);
      newWeek = getWeek(newMonth);
      setCurrentMonth(newMonth);
      setSelectedYear(new Date(newMonth).getFullYear());

      setCurrentWeek(newWeek);
      renderCells(newMonth);
    }
  
    if (btnType === "next") {
      newMonth = addWeeks(currentMonth, 1);
      newWeek = getWeek(newMonth);
      setCurrentMonth(newMonth);
      setSelectedYear(new Date(newMonth).getFullYear());

      setCurrentWeek(newWeek);
      const today = new Date();
      if (getWeek(today) === newWeek) {
        setNextWeekAvailable(false);  
      }
  
      renderCells(newMonth);
    }
  };

  const renderCells = (monn) => {
    console.log(monn,'moon')
    if (weekdays.length != 0) {
      for (let i = 0; i < 7; i++) {
        weekdays.pop();
      }
    }
    const mon = new Date(monn);
    const startDate = startOfWeek(mon, { weekStartsOn: 1 });
    const endDate = lastDayOfWeek(mon, { weekStartsOn: 1 });
    const dateFormat = "EEE, dd MMMM yyyy";
    const rows = [];
    let days = [];
    let day = startDate;
    let formattedDate = "";
    while (day <= endDate) {
      for (let i = 0; i < 7; i++) {
        formattedDate = format(day, dateFormat);
        const cloneDay = day;
        const oneday = {
          id: i,
          fulldate: day,
          day: format(new Date(day), "EEE"),
          date: format(new Date(day), "dd"),
          month: format(new Date(day), "MMM"),
          value:
            format(new Date(), dateFormat) === formattedDate ? true : false,
          isfuture: new Date(formattedDate) > new Date() ? true : false,
        };
        weekdays.push(oneday);
        day = addDays(day, 1);
      }
    }
    let count = 0;
    let dayin = {};
    weekdays.forEach((x) => {
      if (x.value === false) {
        count = count + 1;
      } else {
        dayin = x;
      }
    });
    const next = weekdays;
    if (count === 7) {
      if (!next[0].isfuture) {
        next[0].value = true;
        setSelectedDate(next[0].fulldate);
        setDateSelected(next[0].fulldate);
        setweekdays(next);
        fetchItemList(page, sizePerPage, searchVal, "", "", next[0].fulldate);
      } else {
        setweekdays(next);
        setDateSelected(next[0].fulldate);
        fetchItemList(page, sizePerPage, searchVal, "", "", next[0].fulldate);
      }
    } else {
      setDateSelected(dayin.fulldate);
      fetchItemList(page, sizePerPage, searchVal, "", "", dayin.fulldate);
    }
  };

const handleClick = () => {
  const [start, end] = findUnClosedMonth.split(" to ");
  const startDate = new Date(start);
  const formattedStartDate = startDate.toISOString().split("T")[0];

  setCurrentMonth(startDate);
  setCurrentWeek(getWeek(startDate));

  // 🟢 Add this line — this will make year (Petty Cash YYYY) update dynamically
  setSelectedYear(startDate.getFullYear());

  renderCells(formattedStartDate);
};

  
const handleCalendarSelect = (selectedDate) => {
  if (!selectedDate) return;

  setDateRange(selectedDate);

  // update selected year dynamically
  setSelectedYear(new Date(selectedDate).getFullYear());

  const selectedWeek = getWeek(selectedDate);
  const newMonth = startOfWeek(selectedDate, { weekStartsOn: 1 });

  setCurrentMonth(newMonth);
  setCurrentWeek(selectedWeek);
  renderCells(newMonth);
};

  const onDateClickHandle = (day, dayStr) => {
    setSelectedDate(day);
    showDetailsHandle(dayStr);
  };

  //end

  const parentFunction = () => {
    // setDateSelected(weekdays.forEach((x, i) => x.value  === true ? new Date() : new Date()));
    fetchItemList(
      page,
      sizePerPage,
      searchVal,
      "",
      "",
      dateSelected || new Date()
    );
  };
  const accept = () => {
    const data = {
      CloseType: "Week",
      CloseDate: format(weekdays[6].fulldate, "yyyy-MM-dd"),
      TenantID: GV.userDet.tenantDetail.tenantID,
      CreatedBy: GV.userDet.appUser.appuserID.toString(),
    };
  
    pts
      .ClosePettyCash(data)
      .then((response) => {
        const currentEndDate = new Date(weekdays[6].fulldate);
        const nextWeekStartDate = addDays(currentEndDate, 7);
        const formattedNextWeekStartDate = nextWeekStartDate.toISOString().split('T')[0];
        renderCells(formattedNextWeekStartDate);
        fetchItemList(page, sizePerPage, searchVal, "", "", new Date(dateSelected));
        GetPettycashActiveDays();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const closeMonth = () => {
    const data = {
      CloseType: "Month",
      CloseDate: format(weekdays[6].fulldate, "yyyy-MM-dd"),
      TenantID: GV.userDet.tenantDetail.tenantID,
      CreatedBy: GV.userDet.appUser.appuserID.toString(),
    };
    pts
      .ClosePettyCash(data)
      .then((response) => {
        fetchItemList(
          page,
          sizePerPage,
          searchVal,
          "",
          "",
          new Date(dateSelected)
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const reject = () => {};
  const closeWeek = (event) => {
    confirmPopup({
      target: event.currentTarget,
      message: "Are you sure to close the week?",
      icon: "pi pi-info-circle",
      // acceptClassName: 'p-button-danger',
      accept,
      reject,
    });
  };

  const editProduct = (product) => {
    setItemId(product?.transactionID);
    modalref.current.alertToggledit(product);
  };

  const header = (
    <div className="d-flex justify-content-between align-items-center flex-wrap">
      <div className="text-t-primary  kk-table-header kk-header-sec row">
        <p className="customFont col-xl-12  mb-0">
          <span className=" customFont mb-0 col-sm-12">
            <span className="cc-text-primary">Weekly Topup Amount :</span>{" "}
            {GV.userDet.tenantConfig.currency} {pettyDetails?.length !== 0 ? pettyDetails?.topupAmount?.toFixed(2) : '0.00'}
          </span>{" "}
          &nbsp; &nbsp;{" "}
          <span className="customFont  mb-0 col-sm-12">
            <span className="cc-text-primary">Balance Amount:</span>{" "}
            {GV.userDet.tenantConfig.currency} {pettyDetails?.length !== 0 ? pettyDetails?.closingBalance?.toFixed(2) : "0.00"}
          </span>{" "}
          &nbsp; &nbsp;{" "}
          <span className="customFont mb-0  col-sm-12">
            <span className="cc-text-primary">Weekly Expense:</span>{" "}
            {GV.userDet.tenantConfig.currency} {pettyDetails?.length !== 0 ? pettyDetails?.expence?.toFixed(2) : "0.00"}
          </span>{" "}
        </p>
      </div>
      <div className="my-auto">
        {/* <span onClick={() => { modalref.current.alertToggle(); setItemId(0)}}><i className='pi pi-plus ' ></i> <br/> New Item</span>  */}
        {gridMessage !== "Day does not opened" &&
        pettyDetails?.status !== "Week Closed" &&
        pettyDetails?.status !== "Month Closed" ? (
          <span>
            <button
              className="btn btn-primary py-1 me-2 "
              onClick={() => {
                modalref.current.alertToggle();
                setItemId(0);
              }}
            >
              {" "}
              <i className="pi pi-plus"></i> New Item
            </button>
            <button
              className="btn btn-primary py-1 me-2 "
              onClick={() => {
                modalrefone.current.alertToggle(pettyDetails);
              }}
            >
              {" "}
              <i className="pi pi-plus"></i> Cash Topup
            </button>
          </span>
        ) : gridMessage === "Day does not opened" ? (
          <button
            style={{
              color: "#C43131",
              backgroundColor: "transparent",
              border: "1px solid #C43131",
              padding: "8px 8px",
              borderRadius: "5px",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
            onClick={handleClick}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#F8D7D9")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "transparent")}
          >
            <i className="pi pi-calendar" style={{ marginRight: "8px" }}></i>{" "}
            Close the active week: {findUnClosedMonth}
          </button>
        ) : pettyDetails?.status === "Week Closed" ||
          pettyDetails?.status === "Month Closed" ? (
          <span>Week is closed</span>
        ) : (
          <span></span>
        )}
        {/* <MultiSelect  value={selectedColumns} options={columns} optionLabel="header" optionDisabled="disabled" onChange={onColumnToggle} style={{ width: '3em' }} scrollHeight="400px" dropdownIcon="pi pi-table"
                    tooltip="Custom Columns" tooltipOptions={{ position: 'top' }} panelHeaderTemplate={panelHeaderTemplate} /> */}
      </div>
    </div>
  );
  const amountbody = (data) => {
    return GV.userDet.tenantConfig.currency + " " + data.amountPaid.toFixed(2);
  };
  const balancebody = (data) => {
    return (
      GV.userDet.tenantConfig.currency + " " + data.balanceAmount.toFixed(2)
    );
  };
  const report = () => {
    navigate("/pettycash-report");
  };
  const weekviewReport = () => {
    navigate("/pettycash-weekview");
  };

  const dateFormBodyTemplate1 = (rowData) => {
    return (
      <div>
        {format(
          new Date(rowData?.transactionDate),
          GV.userDet.tenantConfig.dateFormat
        )}
      </div>
    );
  };
  const today = new Date();
  const currentMonthIndex = today.getMonth();
  const currentYear = today.getFullYear();
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  const generateMonthTabs = () => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const startIndex = months.indexOf(GV.userDet.tenantConfig.startMonthName);
    const endIndex = months.indexOf(GV.userDet.tenantConfig.endMonthName);
  
    if (startIndex === -1 || endIndex === -1) {
      throw new Error("Invalid month names provided.");
    }
    const result = [];
    let currentIndex = startIndex;
    while (true) {
      result.push(months[currentIndex]);
      if (currentIndex === endIndex) break;
      currentIndex = (currentIndex + 1) % 12; 
    }
    return result;
  };
 
  const [selectedMonth, setSelectedMonth] = useState(currentMonthIndex);
  const [calendarData, setCalendarData] = useState([]);

  const generateMonthData = (month, year) => {
    const startOfMonth = new Date(year, month, 1);
    const endOfMonth = new Date(year, month + 1, 0);

    const daysInMonth = endOfMonth.getDate();
    const firstDayOfWeek = startOfMonth.getDay();
    const lastDayOfWeek = endOfMonth.getDay();

    const calendarDays = [];
    let week = Array(7).fill(null);

    if (firstDayOfWeek > 0) {
      const prevMonth = month === 0 ? 11 : month - 1;
      const prevYear = month === 0 ? year - 1 : year;
      const prevMonthDays = new Date(prevYear, prevMonth + 1, 0).getDate();

      for (let i = firstDayOfWeek - 1; i >= 0; i--) {
        const date = new Date(prevYear, prevMonth, prevMonthDays - i);
        week[i] = {
          monthDate: date.toISOString().split("T")[0],
          totalRecord: Math.floor(Math.random() * 10),
          totalAmount: Math.random() * 1000,
        };
      }
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day);
      const dayOfWeek = date.getDay();

      week[dayOfWeek] = {
        monthDate: date.toISOString().split("T")[0],
        totalRecord: Math.floor(Math.random() * 10),
        totalAmount: Math.random() * 1000,
      };

      if (dayOfWeek === 6 || day === daysInMonth) {
        calendarDays.push(week);
        week = Array(7).fill(null);
      }
    }

    if (lastDayOfWeek < 6) {
      const nextMonth = month === 11 ? 0 : month + 1;
      const nextYear = month === 11 ? year + 1 : year;

      for (let i = lastDayOfWeek + 1; i <= 6; i++) {
        const date = new Date(nextYear, nextMonth, i - lastDayOfWeek);
        week[i] = {
          monthDate: date.toISOString().split("T")[0],
          totalRecord: Math.floor(Math.random() * 10),
          totalAmount: Math.random() * 1000,
        };
      }
      calendarDays.push(week);
    }

    return calendarDays;
  };

 

  useEffect(() => {
    const data = generateMonthData(selectedMonth, selectedYear);
    setMonthlyViewDatas(data);
  }, [selectedMonth, selectedYear]);

  useEffect(() => {
    generateCalendarData(selectedMonth, currentYear);
  }, [selectedMonth]);

  const generateCalendarData = (monthIndex, year) => {
    const firstDay = new Date(year, monthIndex, 1);
    const lastDay = new Date(year, monthIndex + 1, 0);
    const totalDays = lastDay.getDate();
    const weeks = [];
    let week = new Array(7).fill(null);
    for (let day = 1; day <= totalDays; day++) {
      const date = new Date(year, monthIndex, day);
      const dayOfWeek = date.getDay();
      week[dayOfWeek] = {
        date: date.toLocaleDateString("en-US", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        }),
        status: getRandomStatus(),
        totalEntry: getRandomInt(10, 50),
        totalAmount: getRandomInt(1000, 100000),
      };
      if (dayOfWeek === 6 || day === totalDays) {
        weeks.push(week);
        week = new Array(7).fill(null);
      }
    }
    setCalendarData(weeks);
  };

  const getRandomStatus = () => {
    const statuses = ["Active", "Closed", "Unknown"];
    return statuses[Math.floor(Math.random() * statuses.length)];
  };

  const getRandomInt = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  const changeYear = (direction) => { 
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();
  
    setSelectedYear((prevYear) => {
      const newYear = direction === "prev" ? prevYear - 1 : prevYear + 1;
  
      if (newYear === currentYear) {
        setSelectedMonth(currentMonth);
      } else if (direction === "prev") {
        setSelectedMonth(0); 
      } else {
        setSelectedMonth(0); 
      }
  
      return newYear;
    });
  };

  useEffect(() => {
    if (selectedMonth !== null && selectedYear !== null) {
      passMnoth(selectedMonth, selectedMonth);
    }
  }, [selectedMonth, selectedYear]);

  const getStatusColor = (status) => {
    switch (status) {
      case "Active":
        return "#ff4d4d";
      case "Closed":
        return "#4caf50";
      case "Unknown":
        return "#ffa500";
      default:
        return "#000";
    }
  };
  // useLayoutEffect(() => {
  //   // getDayDetails();
  //   // setDateSelected(weekdays.forEach((x, i) => x.value  === true ? new Date() : new Date()));
  //   renderCells(currentMonth);
  //   fetchItemList(page, sizePerPage, searchVal, "", "", new Date());
  //   return () => {
  //     setIsMounted(false);
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    if (startDate && endDate) {
      const currentMonths = new Date(startDate);
      renderCells(currentMonths);
      setCurrentMonth(currentMonths);
      fetchItemList(1, 10, "", "", "", new Date(startDate));
    } else {
      renderCells(currentMonth);
      fetchItemList(page, sizePerPage, searchVal, "", "", new Date());
    }
  }, []);

  const passMnoth = (month, index) => {
    setTdataLoad(true);
    setSelectedMonth(index);
    const firstDayOfMonth = new Date(selectedYear, index, 1).getDay();
    const formattedMonth = (index + 1).toString().padStart(2, "0");
    pts
      .GetMonthTrancationView(
        GV.userDet.tenantDetail.tenantID,
        selectedYear,
        formattedMonth
      )
      .then((res) => {
        setTdataLoad(false);
        const transactions = res.data.data.transactions;
        setDayTransactionsShowBtn(res.data.data);
        const paddedTransactions = Array(firstDayOfMonth)
          .fill(null)
          .concat(transactions);
        const groupedWeeks = [];
        for (let i = 0; i < paddedTransactions.length; i += 7) {
          groupedWeeks.push(paddedTransactions.slice(i, i + 7));
        }
        setMonthlyViewDatas(groupedWeeks);
      });
  };

  const GetPettycashActiveDays = () => { 
    setTdataLoad(true);
    pts.GetPettycashActiveDays(GV.userDet.tenantDetail.tenantID).then((res) => {
      setTdataLoad(false);
        const data = res.data.data; 
        if (data && data.length > 0) {
            const firstDate = data[0]?.balanceDate.split('T')[0]; 
            const lastDate = data[data.length - 1]?.balanceDate.split('T')[0]; 
            const formattedResult = `${firstDate} to ${lastDate}`;
            setFindUnClosedMonth(formattedResult);
        } else {
            console.log("No data available"); 
        }
    }).catch((error) => {
        console.error("Error fetching active days:", error);
    });
};


  useEffect(() => {
    GetPettycashActiveDays();
    setTdataLoad(true);
    const dateObj = new Date();
    const month = dateObj.getMonth();
    const year = selectedYear;
    setCurrentDate(dateObj.getDate());
    const firstDayOfMonth = new Date(year, month, 1).getDay();
    pts
      .GetMonthTrancationView(
        GV.userDet.tenantDetail.tenantID,
        year,
        String(month + 1).padStart(2, "0")
      )
      .then((res) => {
        setTdataLoad(false);
        const transactions = res.data.data.transactions;
        setDayTransactionsShowBtn(res.data.data);

        const paddedTransactions = Array(firstDayOfMonth)
          .fill(null)
          .concat(transactions);
        const groupedWeeks = [];
        for (let i = 0; i < paddedTransactions.length; i += 7) {
          groupedWeeks.push(paddedTransactions.slice(i, i + 7));
        }
        setMonthlyViewDatas(groupedWeeks);
      });

  }, []);

  useEffect(() => {
    setTdataLoad(true);
    const dateObj = new Date();
    const month = dateObj.getMonth();
    const year = selectedYear;
    setCurrentDate(dateObj.getDate());
    const firstDayOfMonth = new Date(year, month, 1).getDay();
    pts
      .GetMonthTrancationView(
        GV.userDet.tenantDetail.tenantID,
        year,
        String(month + 1).padStart(2, "0")
      )
      .then((res) => {
        setTdataLoad(false);
        const transactions = res.data.data.transactions;
        setDayTransactionsShowBtn(res.data.data);

        const paddedTransactions = Array(firstDayOfMonth)
          .fill(null)
          .concat(transactions);
        const groupedWeeks = [];
        for (let i = 0; i < paddedTransactions.length; i += 7) {
          groupedWeeks.push(paddedTransactions.slice(i, i + 7));
        }
        setMonthlyViewDatas(groupedWeeks);
      });
      setafterNewItem(false);
  }, [afterNewItem]);

  const isToday = (date) => {
    const currentDate = new Date();
    return (
      date &&
      new Date(date.monthDate).getDate() === currentDate.getDate() &&
      new Date(date.monthDate).getMonth() === currentDate.getMonth() &&
      new Date(date.monthDate).getFullYear() === currentDate.getFullYear()
    );
  };

  return (
    <BlockUI blocked={tdataLoad}>
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="card card-borderless cc-greyCard-custm p-2 my-2">
              <div className="row d-flex">
                <div className="col-md-3 col-sm-12 my-2">
  <h4 className="m-0">
    Petty Cash{" "}
    <span style={{ color: "#1e6444", fontSize: "16px", fontWeight: "500" }}>
      ({selectedYear})
    </span>
  </h4>
</div>


                <div className="col-md-9 col-sm-12 d-flex align-items-center justify-content-end">
                  <p className=" customFont mb-0">
                    {" "}
                    <span className="cc-fixed">
                      {GV.userDet.tenantConfig.pettyCashCloseType === "Month"
                        ? "Monthly Opening Balance :"
                        : "Week Opening Balance :"}
                      <b>
                        {GV.userDet.tenantConfig.currency}{" "}
                        {GV.userDet.tenantConfig.pettyCashCloseType === "Month"
                          ? dayTransactionsShowBtn?.openingBalance?.toFixed(2)
                          : pettyDetails?.length !== 0 ? pettyDetails?.openingBalance?.toFixed(2) : "0.00"}
                      </b>
                    </span>
                  </p>
                  {GV.userDet.tenantConfig.pettyCashCloseType !== "Month" ? (
                    <>
                      <span
                        className="ms-3 border-btn"
                        onClick={() => changeWeekHandle("prev")}
                      >
                        {" "}
                        Previous Week{" "}
                      </span>{" "}
                      <span
                        className="ms-3 border-btn"
                        // style={{ display: nextWeekAvailable ? "inline" : "none" }}
                        onClick={() => changeWeekHandle("next")}
                      >
                        {" "}
                        Next Week{" "}
                      </span>
                    </>
                  ) : (
                    <>
                      {!dayDetails && (
                        <>
                          <span
                            className="ms-3 border-btn"
                            onClick={() => changeYear("prev")}
                          >
                            Previous Year
                          </span>
                          {selectedYear < currentYear && (
                            <span
                              className="ms-3 border-btn"
                              onClick={() => changeYear("next")}
                            >
                              Next Year
                            </span>
                          )}
                        </>
                      )}
                    </>
                  )}
                  {/* <span
                    className="ms-3 border-btn"
                    onClick={() => setMonthlyView((prev) => !prev)}
                  >
                    {monthlyView ? "Change Weekly View" : "Change Monthly View"}
                  </span> */}
                    <div className="ms-2" >
     <Calendar
  value={dateRange}
  onChange={(e) => handleCalendarSelect(e.value)}
  placeholder="Select Date"
  dateFormat="dd/mm/yy"
/>

      
    </div>
                  <Tooltip target=".custom-edit-icon" />
                  {GV.userDet.tenantConfig.pettyCashCloseType !== "Month" && (
                    <Tooltip target=".custom-calen-icon" />
                  )}
                  <i
                    className=" pi pi-file-excel mx-2 custom-edit-icon"
                    data-pr-tooltip="Petty Cash Report"
                    data-pr-position="bottom"
                    style={{ color: "#0874df", fontSize: "20px" }}
                    onClick={report}
                  ></i>
                  {GV.userDet.tenantConfig.pettyCashCloseType !== "Month" && (
                    <i
                      className=" pi pi-calendar  custom-calen-icon"
                      data-pr-tooltip="Petty Cash Week View"
                      data-pr-position="bottom"
                      style={{ color: "#1e6444", fontSize: "20px" }}
                      onClick={weekviewReport}
                    ></i>
                  )}
                  
                  {dayDetails && (
                    <button
                      className="btn btn-danger py-1 me-2 mx-2 kk-btnThin my-auto"
                      onClick={() => {
                        setDayDetails(false);
                      }}
                    >
                      {" "}
                      <i className=""></i> Back
                    </button>
                  )}
              
                </div>
              </div>
            </div>
          </div>
        </div>

        <>
          {GV.userDet.tenantConfig.pettyCashCloseType === "Month" ? (
            !dayDetails ? (
              <div className="card card-borderless p-2">
                <div className="d-flex justify-content-between my-1">
                  <div>
                    {generateMonthTabs().map((month, index) => {
                      const currentYear = today.getFullYear();
                      const currentMonth = today.getMonth();

                      const isFutureMonth =
                        (selectedYear === currentYear &&
                          index > currentMonth) ||
                        selectedYear > currentYear;

                      return (
                        <button
                          key={index}
                          style={{
                            padding: "10px 15px",
                            margin: "0 5px",
                            border: "none",
                            backgroundColor:
                              index === selectedMonth ? "#1E6444" : "#e0e0e0",
                            color: index === selectedMonth ? "white" : "black",
                            borderRadius: "5px",
                            cursor: isFutureMonth ? "not-allowed" : "pointer",
                            opacity: isFutureMonth ? 0.6 : 1,
                            transition: "all 0.3s ease",
                          }}
                          onClick={() =>
                            !isFutureMonth && passMnoth(month, index)
                          }
                          disabled={dayTransactionsShowBtn.monthStatus !== "Not Opened"}
                        >
                          {month} {index === selectedMonth && selectedYear}
                        </button>
                      );
                    })}
                  </div>

                  <div></div>
                  {dayTransactionsShowBtn.monthCloseButton && (
                    <span>
                      <button
                        className="btn btn-primary py-1 me-2 "
                        onClick={() => {
                          modalref.current.alertToggle();
                          setItemId(0);
                        }}
                      >
                        {" "}
                        <i className="pi pi-plus"></i> New Item
                      </button>
                      <button
                        className="btn btn-primary py-1 me-2 "
                        onClick={() => {
                          modalrefone.current.alertToggle(pettyDetails);
                        }}
                      >
                        {" "}
                        <i className="pi pi-plus"></i> Cash Topup
                      </button>
                    </span>
                  )}
                </div>
                <div className="card card-borderless cc-greyCard-custm p-3 my-2 d-flex justify-content-between flex-wrap">
                  <div className="text-t-primary  kk-table-header kk-header-sec row">
                    <p className="customFont col-xl-12  mb-0">
                      <span className=" customFont mb-0 col-sm-12">
                        <span className="cc-text-primary">
                          Monthly Topup Amount :
                        </span>{" "}
                        {GV.userDet.tenantConfig.currency +
                          "" +
                          dayTransactionsShowBtn.monthlyTopup?.toFixed(2)}
                      </span>{" "}
                      &nbsp; &nbsp;{" "}
                      <span className="customFont  mb-0 col-sm-12">
                        <span className="cc-text-primary">
                          Balance Amount :
                        </span>{" "}
                        {GV.userDet.tenantConfig.currency +
                          "" +
                          dayTransactionsShowBtn.closingBalance?.toFixed(2)}
                      </span>{" "}
                      &nbsp; &nbsp;{" "}
                      <span className="customFont mb-0  col-sm-12">
                        <span className="cc-text-primary">
                          Monthly Expense:
                        </span>{" "}
                        {GV.userDet.tenantConfig.currency +
                          "" +
                          dayTransactionsShowBtn.monthlyExpence?.toFixed(2)}
                      </span>{" "}
                    </p>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    className="fw-bold"
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(7, 1fr)",
                      fontFamily:
                        "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                      fontSize: "20px",
                    }}
                  >
                    {[
                      "Sunday",
                      "Monday",
                      "Tuesday",
                      "Wednesday",
                      "Thursday",
                      "Friday",
                      "Saturday",
                    ].map((day) => (
                      <div
                        key={day}
                        style={{
                          padding: "10px",
                          textAlign: "center",
                          fontFamily:
                            "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                        }}
                      >
                        {day}
                      </div>
                    ))}
                  </div>

                  {monthlyViewDatas.map((week, weekIndex) => (
                    <div
                      key={weekIndex}
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(7, 1fr)",
                        // gridTemplateRows: "repeat(auto-fill, minmax(100px, auto))",
                        // rowGap:"10px",
                        // columnGap: "10px",
                      }}
                    >
                      {week.map((day, dayIndex) => {
                        const today = new Date();
                        const currentDate = today.toISOString().split("T")[0];
                        const dayDate = day
                          ? day.monthDate.split("T")[0]
                          : null;
                        const dayNumber = day
                          ? day.monthDate.split("T")[0].split("-")[2]
                          : null;
                        const isFutureDate = day && new Date(dayDate) > today;

                        return (
                          <div
                            key={dayIndex}
                            className={` justify-content-center day ${
                              day && !isFutureDate && isToday(day)
                                ? "today fw-bold"
                                : ""
                            }`}
                            style={{
                              padding: "10px",
                              border: `1px solid ${
                                day ? "#D1E9DC" : "#D1E9DC"
                              }`,
                              backgroundColor: day
                                ? isToday(day)
                                  ? "rgb(193 233 195 / 14%)"
                                  : "#fff"
                                : "#fff",
                              minHeight: "100px",
                              textAlign: "center",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              cursor: isFutureDate ? "default" : "pointer",
                              color: isFutureDate ? "#ccc" : "inherit",
                            }}
                          >
                            {day ? (
                              <div
                                onClick={
                                  !isFutureDate
                                    ? () => getSelectedDate(day)
                                    : null
                                }
                                style={{
                                  cursor: isFutureDate ? "default" : "pointer",
                                  color: isFutureDate ? "#ccc" : "inherit",
                                }}
                              >
                                <div
                                  style={{
                                    position: "relative",
                                    left: "-48%",
                                    top: "-5%",
                                    borderRadius: "50%",
                                    // backgroundColor: isToday(day) ? "#6D8A2D" : "#D1D1D1",
                                    color: isToday(day) ? "#6D8A2D" : "#A9A9A9",
                                    textAlign: "center",
                                    textShadow: isToday(day)
                                      ? "rgb(211 211 211) -1px 2px 0px"
                                      : "",
                                  }}
                                >
                                  {dayNumber}
                                </div>
                                {!isFutureDate && (
                                  <>
                                    <div>Total Record: {day.totalRecord}</div>
                                    <div className="" style={{color: day.totalAmount > 0 ? "#6D8A2D" : ""}}>
                                       Amount:{" "}
                                      {GV.userDet.tenantConfig.currency +
                                        "" +
                                        day.totalAmount?.toFixed(2)}
                                    </div>
                                    <div>Balance: {day.closingBalance}</div>

                                  </>
                                )}
                              </div>
                            ) : (
                              <div style={{ color: "#ccc" }}>N/A</div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  ))}
                </div>

                {tdataLoad && (
                  <ProgressSpinner
                    style={{
                      width: "50px",
                      height: "50px",
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                    }}
                    strokeWidth="2"
                    fill="var(--surface-ground)"
                    animationDuration=".5s"
                  />
                )}
                {dayTransactionsShowBtn.monthCloseButton && (
                  <div className="d-flex justify-content-end my-3">
                    <span>
                      <button
                        className="btn btn-danger py-1 me-2 "
                        onClick={closeMonth}
                      >
                        Close Month
                      </button>
                    </span>
                  </div>
                )}
              </div>
            ) : (
              <>
                <div className="card card-borderless cc-greyCard-custm1 mt-3">
                  <div className="card-body ">
                    <div className="account-table">
                      <DataTable
                        value={dayTransactions}
                        loading={tdataLoad}
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 20, 30, 40]}
                      >
                        <Column field="transaction" header="Transaction" />
                        <Column field="transactionCode" header="Code" />
                        <Column field="receiver" header="Receiver" />
                        <Column
                          field="amountPaid"
                          header="Amount Paid"
                          body={amountbody}
                          className="text-end amount-align"
                        />
                        <Column field="isGST" header="GST" body={gstCont} />
                        <Column field="description" header="Description" />
                        <Column
                          field="balanceAmount"
                          header="Balance"
                          body={balancebody}
                          className="text-end amount-align"
                        />
                        <Column
                          field="actionBodyTemplate"
                          header="Action"
                          body={actionBodyTemplate}
                        />
                      </DataTable>
                    </div>
                  </div>
                </div>
              </>
            )
          ) : (
            <div>
              <div className="" style={{ overflow: "hidden" }}>
                <div
                  className="mt-4 row ml-3 ps-4"
                  style={{
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    overflowX: "auto",
                  }}
                >
                  {weekdays.map((item, i) => {
                    return (
                      <div
                        key={i}
                        className={`col-xl col-sm days ${
                          item.isfuture ? "daysDisable" : ""
                        } ${item.value ? "daysSelected" : ""}`}
                        onClick={() => onSelect(item)}
                      >
                        <div
                          className="liClasses"
                          onClick={() => onSelect(item)}
                        >
                          <div className="row">
                            <div className="col-sm-4 day">{item.day}</div>
                            <div className="col-sm-8 date">
                              <span className="d-flex justify-content-center ">
                                {item.month}
                              </span>
                              <span className="d-flex justify-content-center ">
                                <b>{item.date}</b>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="card card-borderless cc-greyCard-custm1">
                <div className="strip"></div>
                <div className="card-body ">
                  <div className="account-table">
                    <DataTable
                      className=""
                      stripedRows
                      paginator
                      value={data}
                      header={header}
                      responsiveLayout="scroll"
                      size="small"
                      loading={tdataLoad}
                      lazy
                      totalRecords={totalRecordsIn}
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      emptyMessage={gridMessage}
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                      rowsPerPageOptions={[10, 20, 50, totalRecordsIn]}
                      first={first1}
                      rows={sizePerPage}
                      onPage={onCustomPage1}
                      onSort={onSort}
                      sortField={lazyParams.sortField}
                      sortOrder={lazyParams.sortOrder}
                    >
                      <Column field="transaction" header="Transaction" />
                      <Column field="transactionCode" header="Code" />
                      <Column field="receiver" header="Receiver" />
                      <Column
                        field="amountPaid"
                        header="Amount Paid"
                        body={amountbody}
                        className="text-end amount-align"
                      />
                      <Column field="isGST" header="GST" body={gstCont} />
                      <Column field="description" header="Description" />
                      <Column
                        field="balanceAmount"
                        header="Balance"
                        body={balancebody}
                        className="text-end amount-align"
                      />
                      <Column
                        field="actionBodyTemplate"
                        header="Action"
                        body={actionBodyTemplate}
                      />
                    </DataTable>
                    <ConfirmPopup />
                    <div className="d-flex justify-content-end mt-2">
                      {weekdays.length !== 0 ? (
                        pettyDetails?.status !== "Week Closed" &&
                        pettyDetails?.status !== "Month Closed" &&
                        gridMessage !== "Day does not opened" ? (
                          <button
                            className="btn btn-danger py-1 me-2 "
                            onClick={closeWeek}
                          >
                            Close Week
                          </button>
                        ) : (
                          <p></p>
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>

        <Dialog
          header="Transaction Detail"
          visible={visibleDetail}
          style={{ width: "50vw" }}
          onHide={() => setVisibleDetail(false)}
        >
          <div className="row mt-3">
            <div className="col-md-2">
              <b>Transaction : </b> <br />
              <b>Code : </b>
              <br />
              <b>Receiver : </b>
              <br />
              <b>Amount Paid : </b>
              <br />
              <b>GST : </b> <br />
              <b>Voucher Code : </b> <br />
              <b>Description : </b> <br />
            </div>
            <div className="col-md-8">
              {detailsTrans?.transaction} <br />
              {detailsTrans?.transactionCode} <br />
              {detailsTrans?.receiver} <br />
              {detailsTrans?.amountPaid} <br />
              {detailsTrans?.isGST === true ? (
                <i className="pi pi-check"></i>
              ) : (
                <i className="pi pi-times"></i>
              )}{" "}
              <br />
              {detailsTrans?.voucher} <br />
              {detailsTrans?.description} <br />
            </div>
          </div>
        </Dialog>

        <NewPettyCash
          ref={modalref}
          parentFunction={parentFunction}
          data={{
            itemId: itemId,
            dateSelected: dateSelected,
            setafterNewItem: setafterNewItem,
          }}
        />

        <CashTopup
          ref={modalrefone}
          parentFunction={parentFunction}
          data={{
            pettyDetails: pettyDetails,
            dateSelected: dateSelected,
            setafterNewItem: setafterNewItem,
          }}
        />
      </div>
    </BlockUI>
  );
}
